import { baseOf } from "./cash";

type CoinAttributes = { name?: string };
type Coin = { attributes?: CoinAttributes };

const DEFAULT_BASE = "BTC";

// A tab restored from sessionStorage can hold a pair from the other cash
// currency (BTC/USDT after the backend switched to USDC). Trading that name
// would send the stale cash ticker, so the saved pair is mapped back onto the
// tournament list: same pair, then same base, then BTC, then the first pair.
export const resolveSelectedCoin = <T extends CoinAttributes>(
  saved: T | null | undefined,
  allCoins: Coin[]
): T | CoinAttributes | undefined => {
  const savedName = saved?.name;
  if (savedName && allCoins.some((coin) => coin.attributes?.name === savedName)) {
    return saved;
  }

  const withBase = (base: string | undefined) =>
    base && allCoins.find((coin) => baseOf(coin.attributes?.name) === base);

  const match =
    withBase(baseOf(savedName)) || withBase(DEFAULT_BASE) || allCoins[0];
  return match?.attributes;
};
